<template>
  <div class="tool-modal-memberkit">
    <hr />
    <bp-select
      v-model="form.product_id"
      id="product-select"
      label="Nome do produto"
      class="mb-3"
      placeholder="Selecionar produto"
      :disabled="isEdit"
      :errors="errors.product_id"
      :options="products.map(({ id, name }) => ({ id, name }))"
      required
    />
    <div class="row">
      <div class="col-lg-12">
        <bp-input
          v-model="form.token"
          id="token"
          class="mb-3"
          label="Informe o token"
          placeholder="Digite o token"
          :errors="errors.token"
          required
        />
      </div>
    </div>

    <div class="row">
      <div class="field-helper mb-2 pl-3">
        Preencha um dos campos abaixo: ID Turma ou ID Assinatura
      </div>
      <div class="col-lg-6">
        <bp-input
          v-model="form.classroom"
          id="classroom"
          label="ID Turma"
          placeholder="Digite o ID da turma"
          :errors="errors.classroom"
          @input="handleClassroomInput"
          :required="!form.membership_level_id"
        />
      </div>
      <div class="col-lg-6">
        <bp-input
          v-model="form.membership_level_id"
          id="signature"
          label="ID Assinatura"
          placeholder="Digite o ID da assinatura"
          :errors="errors.membership_level_id"
          @input="handleMembershipInput"
          :required="!form.classroom"
        />
      </div>
    </div>

    <div class="submit-buttons">
      <bp-button
        color="neutral"
        variant="filled-1"
        label="Cancelar"
        @click="$emit('close')"
      />
      <bp-button
        label="Integrar"
        :loading="loading"
        :disabled="!isValid"
        @click="submit"
      />
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
import IntegrationModalMixin from "@/mixins/integrationModal";

export default {
  mixins: [IntegrationModalMixin],
  data() {
    return {
      ...formFields(
        ["product_id", "token", "classroom", "membership_level_id"],
        this.integrationToEdit
      )
    };
  },

  methods: {
    handleClassroomInput(value) {
      if (value) {
        this.form.membership_level_id = null;
      }
    },

    handleMembershipInput(value) {
      if (value) {
        this.form.classroom = null;
      }
    }
  },

  computed: {
    isValid() {
      return (
        this.form.product_id &&
        this.form.token &&
        (this.form.classroom || this.form.membership_level_id)
      );
    }
  }
};
</script>

<style scoped>
.field-helper {
  color: #666;
  font-size: 0.875rem;
  font-style: italic;
}
</style>
